import { DBConfig } from 'ngx-indexed-db';

export const dbConfig: DBConfig = {
  name: 'CUHKFaceEmotionTaskDB',
  version: 1,
  objectStoresMeta: [
    {
      store: 'participants',
      storeConfig: { keyPath: 'participantIdentifier', autoIncrement: false },
      storeSchema: [
        {
          name: 'participantIdentifier',
          keypath: 'participantIdentifier',
          options: { unique: true },
        },
        {
          name: 'trialSequenceNumber',
          keypath: 'trialSequenceNumber',
          options: { unique: false },
        },
        {
          name: 'experimentProgress',
          keypath: 'experimentProgress',
          options: { unique: false },
        },
        {
          name: 'updateTimeUTC',
          keypath: 'updateTimeUTC',
          options: { unique: false },
        },
      ],
    },
    {
      store: 'responses',
      storeConfig: { keyPath: 'participantIdentifier', autoIncrement: false },
      storeSchema: [
        {
          name: 'participantIdentifier',
          keypath: 'participantIdentifier',
          options: { unique: true },
        },
        {
          name: 'trialSequenceNumber',
          keypath: 'trialSequenceNumber',
          options: { unique: false },
        },
        { name: 'taskData', keypath: 'taskData', options: { unique: false } },
      ],
    },
  ],
};
